import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import classNames from 'classnames';

export default function TimedRedirect({ url, message, delay = 2000, className = '', isCentered = false }) {
  const navigate = useNavigate();

  useEffect(() => {
    const timer = setTimeout(() => {
      navigate(url);
    }, delay);
    return () => clearTimeout(timer);
  }, [navigate, url, delay]);

  const containerClasses = classNames(
    "flex items-center justify-center",
    {
      "min-h-[50vh] h-full w-full flex-col": isCentered
    },
    className
  );

  return (
    <div className={containerClasses}>
      <div className="text-center text-lg text-indigo-400 mb-4">
        {message}
      </div>
    </div>
  );
}
